module.exports = __webpack_public_path__ + "img/detailed-view.400f9609.svg";